// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const FrameworkIcon: MarkdocTagRegistration = {
  tag: 'framework-icon',
  component: 'FrameworkIcon',
  selfClosing: true,
  attributes: {
    type: {
      type: String,
      required: true,
      description:
        'The type of framework, can be either "react", "js", "ios", or "android"',
    },
  },
};
